import React from 'react';

import CallAudio from 'src/assets/audio/call-audio.mp3';

import { Avatar } from 'src/components/basic';
import SVGIcon from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { getRouter } from 'src/helpers';

import model from './model';

export default class Call extends BaseComponent {
  callSound = null;
  constructor(props) {
    super(props);
    this.callSound = new Audio(CallAudio);
    this.callSound.loop = true;
  }

  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('callSound', this.onCallSound);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('callSound', this.onCallSound);
    if (this.audio) {
      this.callSound.pause();
      this.callSound.remove();
    }
  }

  accept = (callerId, callUUID) => {
    model.answerCall({ callUUID });
    getRouter().navigate('/messages/' + callerId);
  };

  hangup = () => {
    console.log('hangup');
    let callUUID = model.state.current;
    if (!callUUID) return console.warn('hangup fail, no callUUID');
    let { state } = model.getCurrent(callUUID);
    if (state === 'ended') {
      model.setState({ current: null });
    } else {
      model.endCall({ callUUID });
    }
  };

  onCallSound = (play) => {
    let callSound = this.callSound;
    if (!callSound) return;
    try {
      if (play) {
        callSound.pause();
        callSound.currentTime = 0;
      }
      if (play && callSound.paused) {
        callSound
          .play()
          .then(function () {})
          .catch(function (error) {
            this.log(error);
          });
      } else if (!play && !callSound.paused) {
        callSound.pause();
        callSound.currentTime = 0;
      }
    } catch (err) {
      this.warn('callSound err', err);
    }
  };

  render() {
    const callUUID = model.state.current;
    const {
      state,
      isCallee,
      callerId,
      partnerName = '',
      partnerAvatar,

      video
    } = model.getListState(callUUID);

    let avatar = partnerAvatar;
    if (avatar) avatar = avatar.replace('/full_', '/350_');
    let name = partnerName;
    let isVideoCall = !!video;

    if (
      !(state == 'requested' && isCallee && window.location.pathname != '/messages/' + callerId)
    ) {
      return <div />;
    }

    return (
      <div className='mc-popup show'>
        <div className={'mc-popup-transfer'}>
          <div className={'mc-popup-cover show'}></div>
          <div className={'mc-call'} style={{ padding: 30, width: 350 }}>
            <div className={'mc-btn-bar'}>
              <div className={'mc-main-bar'}>
                <div
                  className={'mc-circle-btn'}
                  style={{ transform: 'rotate(180deg)', width: 50, height: 50 }}
                  onClick={() => this.accept(callerId, callUUID)}
                >
                  <SVGIcon width={50} iconname={'accept-call-icon'} />
                </div>
                <div
                  className={'mc-circle-btn'}
                  style={{ width: 50, height: 50 }}
                  onClick={this.hangup}
                >
                  <SVGIcon width={50} iconname={'stop-call-icon'} />
                </div>
              </div>
            </div>
            <div className={'mc-connecting'}>
              <Avatar text={name} width={100} height={100} image={avatar} />
              <div className={'mc-text'}>
                <div className='mc-call-status'>{name}</div>
              </div>
              <div className={'mc-text'}>
                <div className='mc-call-status'>{`Incoming ${isVideoCall ? 'video ' : ''}call`}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
